"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAliases = void 0;
var index_1 = require("./link/index");
var globals_1 = require("../globals");
var button_1 = require("./button");
var colors_1 = require("./colors");
var heading_1 = require("./heading");
var textInput_1 = require("./textInput");
var label_1 = require("./label");
var paragraphs_1 = require("./paragraphs");
var validation_1 = require("./validation");
var logo_1 = require("./logo");
var sidebar_1 = require("./sidebar");
var checkbox_1 = require("./checkbox");
var getAliases = function (brand, isNativeIOS) {
    var globals = (0, globals_1.getGlobals)(brand, isNativeIOS);
    return {
        button: (0, button_1.getButtonAliases)(globals, brand),
        heading: (0, heading_1.getHeadingAliases)(globals, brand),
        colors: (0, colors_1.getAliasColors)(globals, brand),
        link: (0, index_1.getLinkAliases)(globals, brand),
        textInput: (0, textInput_1.getTextInputAlias)(globals, brand),
        label: (0, label_1.getLabelAlias)(globals, brand),
        paragraphs: (0, paragraphs_1.getParagraphsAlias)(globals, brand),
        validation: (0, validation_1.getValidationAlias)(globals),
        logo: (0, logo_1.getLogoAlias)(globals, brand),
        sidebar: (0, sidebar_1.getSidebarAlias)(globals),
        checkbox: (0, checkbox_1.getCheckboxAlias)(globals),
    };
};
exports.getAliases = getAliases;
